import type { UpdateListingButtonsRequest } from '@pulsify/shared/dto'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { listingButtonsApi } from '~/entities/listing-buttons/api/listing-buttons-api'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'

export function useListingButtons(businessId: string, listingId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.LISTING_BUTTONS, listingId),
    queryFn: () => listingButtonsApi.get(businessId, listingId),
    staleTime: MINUTES,
    enabled: !!businessId && !!listingId,
  })
}

export function useUpdateListingButtons(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ listingId, chosen }: { listingId: string } & UpdateListingButtonsRequest) =>
      listingButtonsApi.update(businessId, listingId, { chosen }),
    onSuccess: (state, { listingId }) => {
      queryClient.setQueryData(queryKey(QueryKey.LISTING_BUTTONS, listingId), state)
      queryClient.invalidateQueries({ queryKey: queryKey(QueryKey.LISTING, listingId) })
    },
  })
}
